
import React from 'react';
import { Page } from '../types';

interface FooterProps {
    onNavigate: (page: Page) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-black border-t border-gray-800">
            <div className="container mx-auto px-6 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    <div>
                        <h3 className="text-lg font-bold text-white uppercase">CTT Força e Ação</h3>
                        <p className="mt-2 text-gray-400 text-sm leading-relaxed">
                            Centro de Treinamento de Tiro Força e Ação.<br />
                            Responsável: <strong className="text-gray-300">Luiz Junior</strong><br />
                            Av. Djalma Castro Alves, 1241 — Uberaba - MG
                        </p>
                        <div className="mt-3 flex flex-col gap-1 text-sm">
                            <a href="tel:3431733373" className="text-gray-400 hover:text-red-500 transition-colors">📞 (34) 3317-3373</a>
                            <a href="https://wa.me/5534992742478" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-red-500 transition-colors">💬 WhatsApp: (34) 99274-2478</a>
                            <a href="https://www.cttforcaeacao.com.br" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-red-500 transition-colors">🌐 cttforcaeacao.com.br</a>
                        </div>
                    </div>
                    <div>
                        <h3 className="text-md font-semibold text-gray-200 uppercase tracking-wider">Links Rápidos</h3>
                        <ul className="mt-4 space-y-2">
                            <li><button onClick={() => onNavigate('marketplace')} className="text-gray-400 hover:text-red-500 transition-colors bg-transparent border-none text-left p-0">Marketplace</button></li>
                            <li><button onClick={() => onNavigate('cac-services')} className="text-gray-400 hover:text-red-500 transition-colors bg-transparent border-none text-left p-0">Serviços CAC</button></li>
                            <li><button onClick={() => onNavigate('legal-support')} className="text-gray-400 hover:text-red-500 transition-colors bg-transparent border-none text-left p-0">Apoio Jurídico</button></li>
                            <li><button onClick={() => onNavigate('faq')} className="text-gray-400 hover:text-red-500 transition-colors bg-transparent border-none text-left p-0">FAQ</button></li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-md font-semibold text-gray-200 uppercase tracking-wider">Legal</h3>
                        <ul className="mt-4 space-y-2">
                            <li><button className="text-gray-400 hover:text-red-500 transition-colors bg-transparent border-none text-left p-0">Termos de Serviço</button></li>
                            <li><button className="text-gray-400 hover:text-red-500 transition-colors bg-transparent border-none text-left p-0">Política de Privacidade</button></li>
                            <li><button className="text-gray-400 hover:text-red-500 transition-colors bg-transparent border-none text-left p-0">Aviso Legal</button></li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="text-md font-semibold text-gray-200 uppercase tracking-wider">Aviso Importante</h3>
                        <p className="mt-4 text-gray-500 text-sm">
                            A comercialização de armas de fogo no Brasil é restrita e depende de autorização prévia do órgão competente. Atuamos em estrita conformidade com a legislação vigente.
                        </p>
                    </div>
                </div>
                <div className="mt-12 border-t border-gray-800 pt-8 text-center text-gray-500 text-sm">
                    <p>&copy; {currentYear} CTT FORÇA E AÇÃO — Centro de Treinamento de Tiro. Todos os direitos reservados.</p>
                    <p className="mt-1 text-gray-600 text-xs">by lions intelligence</p>

                </div>
            </div>
        </footer>
    );
};

export default Footer;
